export var Alignment;
(function (Alignment) {
    Alignment["Left"] = "left";
    Alignment["Center"] = "center";
    Alignment["Right"] = "right";
})(Alignment || (Alignment = {}));
export var searchResultsSettings = {
    isSearchBarEnabled: {
        key: 'isSearchBarEnabled',
        getDefaultValue: function () {
            return true;
        },
    },
    searchBarPlaceholder: {
        key: 'searchBarPlaceholder',
        getDefaultValue: function () {
            return 'Search...';
        },
    },
    itemsPerPage: {
        key: 'itemsPerPage',
        getDefaultValue: function () {
            return 10;
        },
    },
    isResultsMessageWithQuery: {
        key: 'isResultsMessageWithQuery',
        getDefaultValue: function () {
            return false;
        },
    },
    isResultsMessageWithNumber: {
        key: 'isResultsMessageWithNumber',
        getDefaultValue: function () {
            return true;
        },
    },
    isResultsEmptyMessageWithNumber: {
        key: 'appLayout',
        getDefaultValue: function () {
            return false;
        },
    },
    isResultsEmptyMessageWithQuery: {
        key: 'isResultsEmptyMessageWithQuery',
        getDefaultValue: function () {
            return false;
        },
    },
    resultsMenuAlignment: {
        key: 'resultsMenuAlignment',
        getDefaultValue: function () {
            return Alignment.Left;
        },
    },
    paginationAlignment: {
        key: 'paginationAlignment',
        getDefaultValue: function () {
            return Alignment.Center;
        },
    },
};
//# sourceMappingURL=searchResultsSettings.js.map